import { BlockReferenceArray } from '@/cms/types/block';
import { BlockComponentModel } from '@/cms/types/blok-component';
import { OpenPositions } from './OpenPositions';
import { transformOpenPositions } from './transformer';

export type OpenPositionsStrapiProps = {
  title?: string;
  pages: BlockReferenceArray<{ slug: string; seo?: { metaTitle?: string } }>;
};

export async function OpenPositionsStrapi({
  block,
}: BlockComponentModel<OpenPositionsStrapiProps>) {
  const data = await transformOpenPositions(block);
  return <OpenPositions {...data} />;
}
